// src/components/assets/EditAssetModal.tsx
import React, { useCallback } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { Vehicle as Asset } from "../../state/types";
import { UploadState } from "../../hooks/vehicles/useUploadAsset";
import uploadAndProcessImages from "../vehicles/FileUploading/uploadRequests";
import UploadAsset from "../vehicles/FileUploading/UploadAsset";
import { useAsset } from "../../context/AssetContext";

const EditAssetModal: React.FC = () => {
  const {
    asset,
    isEditAssetModalOpen, // Get the new state from the context
    closeEditAssetModal,  // Get the new close function
  } = useAsset();

  if (!asset) return <></>

  const handleUpdateAsset = useCallback(async (state: UploadState) => {
    const { vehicle: updatedAssetState, uploadedFiles } = state;

    const modifiedImageArrays: Record<string, any[]> = {};
    Object.keys(updatedAssetState).forEach(key => {
      if (key.startsWith('image') && Array.isArray(updatedAssetState[key as keyof Asset])) {
        if (JSON.stringify(updatedAssetState[key as keyof Asset]) !== JSON.stringify(asset[key as keyof Asset])) {
          modifiedImageArrays[key] = updatedAssetState[key as keyof Asset] as any[];
        }
      }
    });

    try {
      await uploadAndProcessImages(asset, uploadedFiles, modifiedImageArrays);
      closeEditAssetModal();
    } catch (error) {
      console.error("Failed to update asset:", error);
    }
  }, [asset, closeEditAssetModal]);

  return (
    <Dialog open={isEditAssetModalOpen} onClose={closeEditAssetModal} fullWidth maxWidth="lg">
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Asset Media Manager</Typography>
          <IconButton onClick={closeEditAssetModal} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ pt: 1 }}>
        <UploadAsset
          key={asset.pk}
          title="" // Title is now in the DialogTitle, so we can hide this
          initialVehicle={asset}
          onSave={handleUpdateAsset}
        />
      </DialogContent>
    </Dialog>
  );
};

export default EditAssetModal;